/**
 * @description 网关服务前缀
 */
export default class ApiPrefix {
  /**
   * @description 帖子服务
   */
  static COMMUNITY = '/portal-api'

  /**
   * @description customer服务
   */
  static CUSTOMER = '/portal-api'

  /**
   * @description topic服务
   */
  static TOPIC = '/portal-api'

  /**
   * @description admin服务
   */

  static ADMIN = '/portal-api'

  /**
   * @description campaign服务
   */

  static CAMPAIGN = '/portal-api'

  /**
   * @description tribe服务
   */

  static TRIBE = '/portal-api'

  /**
   * @description tribe服务
   */

  static VIOLATION = '/portal-api'

  /**
   * @description admin服务
   */

  static ADMINBFF = '/portal-api'
}
